import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// services
import { SharedServices } from './services';

// components
import { SharedComponents } from './components';

// directives
import { SharedDirectives } from './directives';

// pipes
import { SharedPipes } from './pipes';

// External
import { TranslateModule } from '@ngx-translate/core';
import { NgbAlertModule, NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';

// Material
import { MaterialUIComponents } from './material.declarations';

@NgModule({
  imports: [
    CommonModule,
    NgbAlertModule,
    NgbTabsetModule,
    TranslateModule,
    RouterModule,
    MaterialUIComponents()
  ],
  exports: [
    TranslateModule,
    NgbAlertModule,
    NgbTabsetModule,
    SharedComponents(),
    SharedDirectives(),
    SharedPipes(),
    MaterialUIComponents()
  ],
  providers: [
    SharedServices()
  ],
  declarations: [
    SharedDirectives(),
    SharedPipes(),
    SharedComponents()
  ]
})
export class SharedModule { }
